import { Page, type PageAction } from 'corso-admin-ui';
import { type ComponentProps, type PropsWithChildren } from 'react';
import { useStoreContext } from '~/providers/StoreProvider';

export function StorePage({
  title,
  children,
  primaryAction,
  secondaryActions,
}: PropsWithChildren<{
  title: string;
  primaryAction?: PageAction;
  secondaryActions?: ComponentProps<typeof Page>['secondaryActions'];
}>) {
  const store = useStoreContext();

  return (
    <Page
      title={title}
      subtitle={store.name}
      size="fullWidth"
      primaryAction={primaryAction}
      secondaryActions={secondaryActions}
    >
      {children}
    </Page>
  );
}
